import { boolean, number, object, omit, string } from 'superstruct';
import { EditPermissionsDto } from '@arc/shared/util-data';
export const ViewRoleDto = object({
  name: string(),
  superuser: boolean(),
  permissions: EditPermissionsDto,
  id: number(),
  archived: boolean(),
  isAdmin: boolean()
});
export const ViewRoleListedDto = omit(ViewRoleDto, ['permissions']);